module.exports = __webpack_public_path__ + "img/banner988.3d488020.png";